import React, { useCallback, useEffect, useState } from 'react'
import { Badge, Card, Modal } from 'react-bootstrap'
import {  useMediaQuery } from '@material-ui/core';
import { projectFirestore } from '../firebase/config';
import { MdRefresh } from "react-icons/md";
import { useAuthContext } from "../hooks/useAuthContext";
import { PieChart, Pie, Cell } from "recharts";

export default function ({openStats, setOpenStats}) {

    const isSmallScreen = useMediaQuery('(max-width: 600px)');
    const { user } = useAuthContext()
    const [counts, setCounts] = useState({
      pending: 0,
      approved: 0,
      rejected: 0,
    });
  
      const [isRefreshing, setIsRefreshing] = useState(false);
      const [cachedCounts, setCachedCounts] = useState(null);
    

  
      const refreshCounts = useCallback(() => {
        const notRegistered = [];
        const rejected = [];
      
        if (!isRefreshing) {
          setIsRefreshing(true);
          // Query the "students" collection for counts with specific supervisor
                      
          projectFirestore
            .collection("students")
            .where("supervisor", "==", user?.email.match(/^(.*?)@/)?.[1] )
            .get()
            .then((querySnapshot) => {
              let newCounts = {
                pending: 0,
                approved: 0,
                rejected: 0,
                notRegistered: 0,
                dismissedOrGraduated: 0,
              };
              querySnapshot.forEach((doc) => {
                const status = doc.data().status;
                const data = doc.data();
                if (status === "Pending") {
                  newCounts.pending++;
                } else if (status === "Approved") {
                  newCounts.approved++;
                } else if (status === "Rejected") {
                  rejected.push(data.student_id)
                  newCounts.rejected++;
                } else if (!data.hasOwnProperty("updatedAt")) {
                  notRegistered.push(data.student_id);
                  newCounts.notRegistered++;
                } else if (!data.academic_status || data.academic_status === "DISM") {
                  newCounts.dismissedOrGraduated++;
                }
              });
              // Cache the new counts
              setCachedCounts(newCounts);
              setCounts(newCounts);
              setIsRefreshing(false);
            })
            .catch((error) => {
              console.log("Error getting students:", error);
              setIsRefreshing(false);
            });
        }

    if (!isRefreshing) {
      setIsRefreshing(true);
      // Query the "students" collection for counts
      projectFirestore
        .collection("students")
        .get()
        .then((querySnapshot) => {
          let newCounts = {
            pendingApproval: 0,
            approved: 0,
            rejected: 0,
            notRegistered: 0,
            pendingRegistration: 0,
            notRegistered: 0,
            dismissedOrGraduated: 0

          };
          querySnapshot.forEach((doc) => {
            const status = doc.data().status;
            const data = doc.data();
            const newSubjects = data.new_subjects; // Check for new subjects

           if (status === "Pending") {
          if (newSubjects && newSubjects.length > 0) {
            // Increment pendingApproval count if status is pending and new subjects exist
            newCounts.pendingApproval++;
          } else {
            // Increment pendingRegistration count if status is pending but no new subjects
            newCounts.pendingRegistration++;
          }
            } else if (status === "Approved") {
              // Increment approved count
              newCounts.approved++;
            } else if (status === "Rejected") {
              // Add to rejected array and increment rejected count
              rejected.push(data.student_id);
              newCounts.rejected++;
            } else if (!data.hasOwnProperty("updatedAt")) {
              // Handle not registered case
              notRegistered.push(data.student_id);
              newCounts.notRegistered++;
            } else   if (!data.academic_status || data.academic_status === "DISM") {
              newCounts.dismissedOrGraduated++;
            }
          });

          // Cache the new counts
          setCachedCounts(newCounts);
          setCounts(newCounts);
          setIsRefreshing(false);
          console.log('notregistered', notRegistered)
        })
        .catch((error) => {
          console.log("Error getting students:", error);
          setIsRefreshing(false);
        });
    }
  }, [isRefreshing]);

  useEffect(() => {
    if (cachedCounts) {
      setCounts(cachedCounts);
    } else {
      refreshCounts();
    }
  }, [cachedCounts, refreshCounts]);

  const handleRefresh = useCallback(() => {
    if (!isRefreshing) {
      setCachedCounts(null);
      refreshCounts();
    }
  }, [isRefreshing, refreshCounts]);

  const debouncedRefresh = useCallback(
    debounce(handleRefresh, 1000, { leading: true, trailing: false }),
    [handleRefresh]
  );

  function debounce(func, wait, options) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        timeout = null;
        if (!options.leading) func(...args);
      };
      const shouldCallNow = options.leading && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (shouldCallNow) func(...args);
    };
  }

  const data = [
    { name: "مقبول", value: counts.approved },
    { name: "مرفوض", value: counts.rejected },
    { name: "قيد المراجعة", value: counts.pendingApproval },
    { name: "لم يسجل بعد", value: counts.pendingRegistration },
    {name: "غير موجود في المنصة", value: counts.notRegistered}
  ];

  const COLORS = ["#28a745", "#dc3545",  "#ffd700", "#007bff"];

  return (

    <div>

      <Modal
        className="comment-modal dash"
        size={isSmallScreen ? "sm" : "lg"}
        show={openStats}
        centered
        onHide={() => setOpenStats(false)}>
       
       <Modal.Header className="btn-close-white" closeButton>
       
        </Modal.Header>
      
        <Modal.Body className="comment-modal dash">
        <Card className="comment-card dash" style={{border: 'none !important'}}>
                    <Card.Header  className="text-center title-stats" style={{fontSize: '40px', border: 'none !important'}}>
                       <MdRefresh 
                      //  onClick={debouncedRefresh} 
                    /> احصائيات 
                    </Card.Header>
                    <Card.Body  style={{display: 'flex', justifyContent: 'space-around', flexDirection: 'row'}}>
                    {/* <p className="stats" style={{fontSize: '30px'}}> <Badge text="dark" bg="warning"> قيد التسجيل </Badge>   :   {counts.pending}</p>
                    <p className="stats"  style={{fontSize: '30px'}}> <Badge bg="success"> مقبول </Badge> : {counts.approved}</p>
                    <p className="stats"  style={{fontSize: '30px'}}> <Badge bg="danger"> مرفوض </Badge> : {counts.rejected}</p>
                    <p className="stats"  style={{fontSize: '30px'}}> <Badge bg="primary"> لم يسجل مواد </Badge> : {counts.notRegistered}</p>
              <p className="stats" style={{fontSize: '30px'}}> <Badge text="dark" bg="warning"> قيد التسجيل </Badge>   :   {counts.pending}</p> */} 
              <div style={{ display: 'flex', alignItems: 'center' }}>
      <div style={{ flex: 1, fontSize: '30px' }}>
        <div className="stats">
          <Badge bg="success"> مقبول </Badge> : {counts.approved}
        </div>
        <div className="stats">
          <Badge bg="danger"> مرفوض </Badge> : {counts.rejected}
        </div>
        <div className="stats">
          <Badge bg="primary">  لم يسجل بعد </Badge> : {counts.pendingRegistration}
        </div>
        <div className="stats">
          <Badge bg="warning" text="dark" > قيد المراجعة </Badge> : {counts.pendingApproval}
        </div>
      </div>
      <div style={{ flex: 1 }}>
        <PieChart width={400} height={400}>
          <Pie
            data={data}
            cx={200}
            cy={200}
            outerRadius={80}
            fill="#8884d8"
            label
          >
            {data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
            ))}
          </Pie>
        </PieChart>
      </div>
    </div>

            </Card.Body>
          </Card>
        </Modal.Body>
   
      </Modal>

    </div>
  )
}
